<template>
  <Card class="dummy-page-item">
    <div class="row">
      <div class="col-md-8 push-md-4">
        <div class="page-summary-container">
          <div class="page-summary">
            <div class="block-1"></div>
            <div class="block-2"></div>
            <div class="block-3"></div>
          </div>
        </div>
      </div>

      <div class="col-md-4 pull-md-8">
        <div class="card-top-info">
          <div class="block-1"></div>
          <div class="block-2"></div>
        </div>

        <div class="card-bottom-info">
          <div class="block-1"></div>
          <div class="block-2"></div>
          <div class="block-3"></div>
        </div>
      </div>

    </div>
  </Card>
</template>

<script>
  export default {
    name: 'dummy-page-item',
  };
</script>

<style lang="scss">
  .dummy-page-item {
    min-height: 200px;

    .page-summary-container {
      padding-top: 20px;
      padding-bottom: 20px;
      border-bottom: solid 1px rgba(0, 0, 0, 0.12);

      @media (min-width: 768px) {
        border-bottom: none;
      }
    }

    .page-summary {
      height: 160px;
      padding-left: 20px;
      padding-right: 20px;

      @media (min-width: 768px) {
        border-left: solid 1px rgba(0, 0, 0, 0.12);
      }

      .block-1 {
        width: 40px;
        max-width: 100%;
        height: 12px;
        background-color: #f7f7f7;
        margin-bottom: 22px;
      }

      .block-2 {
        width: 540px;
        max-width: 100%;
        height: 12px;
        background-color: #f7f7f7;
        margin-bottom: 8px;
      }

      .block-3 {
        width: 400px;
        max-width: 100%;
        height: 12px;
        background-color: #f7f7f7;
      }
    }

    .card-top-info,
    .card-bottom-info {
      padding: 20px;
    }

    .card-top-info {
      .block-1 {
        width: 180px;
        max-width: 100%;
        height: 24px;
        background-color: #eeeeee;
        margin-bottom: 12px;
      }

      .block-2 {
        width: 140px;
        max-width: 100%;
        height: 12px;
        background-color: #eeeeee;
      }
    }

    .card-bottom-info {
      @media (min-width: 768px) {
        width: 100%;
        position: absolute;
        bottom: 0px;
      }

      .block-1,
      .block-2,
      .block-3 {
        width: 116px;
        max-width: 100%;
        height: 12px;
        background-color: #eeeeee;
      }

      .block-1,
      .block-2 {
        margin-bottom: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DummyPageItem.vue